export default class WebshopkosarClass {

    removeItem(el) {
        var num = 1;

        num = +$(el).parents('tr').find('td.db select').val();

        var type = "" + $(el).data('termek_type');

        if (type.indexOf('a') == 0) {
            num = 1;
        }

        if (
            typeof kosarGTMDataLayerObj != "undefined"
            && $(el).data('termek_id') > 0
            && kosarGTMDataLayerObj[$(el).data('termek_id')]
        ) {
            window.GTMDataPusher.listItemRemoveFromCart(kosarGTMDataLayerObj[$(el).data('termek_id')])
        }

        $.get('/webshop/kosarbol', {
            'id': $(el).data('termek_id'),
            'type': type,
            'force': 1,
            'szett_id': +$(el).data('termek_szett_id') > 0 ? +$(el).data('termek_szett_id') : 0,
            'num': num
        }, function () {
            $('.page .page-body').addClass('loading');
            // window.Webshopkosar.saveKosarToBrowser(true);
            window.location.reload()
        }, "json");

        return false;
    }

    updateAr(id, ar, type, tid, keys, el) {
        var keystatus = "&keyup=1";

        var pontstatus = false;

        var selEl = $('#kdarab' + id);

        if ($(el).length > 0) {
            selEl = $(el);
        }

        if (typeof el != "undefined" && selEl.length > 0 && selEl.data('pontbevaltas')) {
            pontstatus = true;
        }


        if (pontstatus) {
            var datas = {};
            datas['termek_id'] = tid;
            datas['db_1'] = +selEl.val();
            datas['type_1'] = type;
            datas['pontbevaltas'] = 1;

            $.post('/index.php/kosar/ad', datas, function () {
                // window.location.reload();
            });

        } else {
            $('.page .page-body').addClass('loading');
            $.post('/index.php/webshop/kosarba?id=' + tid + "&num=" + +selEl.val() + "&set=1&type=" + type + keystatus + '&t=' + (new Date().getTime()), {}, function () {
                var isStepParameter = document.location.href.indexOf("step");
                var stepValue = "";
                if (isStepParameter != -1) {
                    stepValue = document.location.href.substring(isStepParameter + 5);
                }
                $.get('/index.php/webshop/services/kosarpanel_load?mode=2026&step=' + stepValue + '&t=' + (new Date().getTime()), function (res) {
                    $('.kosarpanel-container').html(res.html);
                    $('.kosarpanel-container').removeClass('loading');
                    $('.page .page-body').removeClass('loading');
                    $('.uj-kosar-kont .page-footer .btn').removeAttr('disabled');
                }).fail(function () {
                    $('.page .page-body').removeClass('loading');
                    $('.uj-kosar-kont .page-footer .btn').removeAttr('disabled');
                });
            });
        }
    }

    tovabbClickTest() {
        var ret = true
        $('.radio-error-kont').hide();

        // dpd-t választott de dpd üres
        if ($("#atvetel_helye_6").is(":checked") && $('#pickup_dpd_id').val() == '') {
            ret = false;
            $("#atvetel_helye_6").parents('.select-item').find('.radio-error-kont').show()
        }

        // pickupot választott de pickup üres
        if ($("#atvetel_helye_5").is(":checked") && $('#pickup_reco_id').val() == '') {
            ret = false;
            $("#atvetel_helye_5").parents('.select-item').find('.radio-error-kont').show()

        }

        // gls-t de pickup üres
        if ($("#atvetel_helye_7").is(":checked") && $('.page.szallitas .gls-valaszto-kont [name="pickup_gls_data"]').val() == '') {
            ret = false;
            $("#atvetel_helye_7").parents('.select-item').find('.radio-error-kont').show();
            $("html, body").animate({ scrollTop: $('.select-item.gls-csomagpont').offset().top - 200 }, "slow");

        }

        if ($("#atvetel_helye_10").is(":checked") && $('[name=pickup_posta_data]').val() == '') {
            ret = false;
            $("[name=pickup_posta_data]").parent().find('.radio-error-kont').show()
        }

        if (ret && $('[name=order_type]:checked').length == 0) {
            ret = false;
            $('.radio-error-kont.fizmod').show();
        }


        return ret;

    }

    kuponkodformSubmit(f) {
        if ($('.kupon-bevaltas-form input:text', $(f)).length > 0) {
            if ($('.kupon-bevaltas-form input:text', $(f)).val() == "") {
                return false;
            }
        }
        //$('<div>').addClass('kosar-loader').appendTo('body');

        return true;
    }

    kuponkodvasarloiformSubmit(f) {
        if ($('.kupon-vasarloi-bevaltas-form input:checkbox:checked', $(f)).length > 0) {
            return false;
        }
        $('<div>').addClass('kosar-loader').appendTo('body');

        return true;
    }

    kuponkodOpenSelector() {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));

        $('.pms-main-win').css('top', ((window.innerHeight / 2) - ($('.pms-main-win').height() / 2)) + 'px');

        $.get('/index.php/webshop_hu/kosar/kuponvalaszto_dialog', { r: new Date().getTime() }, function (res) {
            if (res != '') {
                $('.pms-message').html(res);
                $('.pms-main-win').css('top', ((window.innerHeight / 2) - ($('.pms-main-win').height() / 2)) + 'px');

            }
        }, 'html');

        return false;
    }

    changeSelectItemActive(inp_name) {
        $('[name=' + inp_name + ']').each(function (i, radi) {
            if ($(radi).is(':checked')) {
                $(radi).parents('.select-item').addClass('active');
            } else {
                $(radi).parents('.select-item').removeClass('active');
            }
        })
    }

    utalvanybevaltasPopUp() {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();

        var popu = $('.ajandekutalvany-form.proto').clone();
        $(popu).removeClass('proto');
        $(popu).find('[name=utalvanykod_proto]').attr('name', 'utalvanykod')
        $(popu).appendTo($('.pms-message'));

        $('.pms-main-win')
            .addClass('ajandekutalvany-window')
            .css('top', ((window.innerHeight / 2) - ($('.pms-main-win').height() / 2)) + 'px');

        return false;

    }

    egyforintosakcioPopUp() {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();

        var popu = $('.ajandekutalvany-form.proto').clone();
        $(popu).removeClass('proto');
        $(popu).find('[name=utalvanykod_proto]').attr('name', 'utalvanykod')
        $(popu).appendTo($('.pms-message'));

        $('.pms-main-win')
            .addClass('ajandekutalvany-window')
            .css('top', ((window.innerHeight / 2) - ($('.pms-main-win').height() / 2)) + 'px');

        return false;

    }

    static adoszamInputCheck(value) {
        // VAT number validation
        var adoszam = value.replace(/[^0-9]/g, '');
        if (adoszam.length !== 13) {
            return false;
        }
        // Simple validation - can be enhanced
        return true;
    }

}
